import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import HIW1img from "images/HIW1img.png";
import HIW2img from "images/HIW2img.png";
import HIW3img from "images/HIW3img.png";
import HIW4img from "images/HIW4img.png";
import VectorImg from "images/VectorHIW.svg";
import Badge from "shared/Badge/Badge";

export interface SectionHowItWorkProps {
  className?: string;
  data?: typeof DATA[0][];
}

const DATA = [
  {
    id: 1,
    img: HIW1img,
    imgDark: HIW1img,
    title: "Find & Filter",
    desc: "Browse a large selection of captivating on-chain NFTs and artists with ease",
  },
  {
    id: 2,
    img: HIW2img,
    imgDark: HIW2img,
    title: "A New Experience",
    desc: "Explore new ways to interact with your artwork like never before",
  },
  {
    id: 3,
    img: HIW3img,
    imgDark: HIW3img,
    title: "Curated Works",
    desc: "Specialising in on-chain minting, only the highest quality approved by the team",
  },
  {
    id: 4,
    img: HIW4img,
    imgDark: HIW4img,
    title: "Grow Your Collection",
    desc: "Receive token rewards and perks as you acquire new artwork for your collection",
  },
];

const SectionHowItWork: FC<SectionHowItWorkProps> = ({
  className = "",
  data = DATA,
}) => {
  return (
    <div
      className={`nc-SectionHowItWork  ${className}`}
      data-nc-id="SectionHowItWork"
    >
      <div className="relative grid sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-16 xl:gap-20">
        <img
          className="hidden md:block absolute inset-x-0 -top-1"
          src={VectorImg}
          alt="vector"
        />
        {data.map((item: typeof DATA[number], index: number) => (
          <div
            key={item.id}
            className="relative flex flex-col items-center max-w-xs mx-auto"
          >
            <NcImage
              containerClassName="mb-5 sm:mb-10 lg:mb-20 max-w-[96px] mx-auto"
              src={item.img}
            />
            <div className="text-center mt-auto space-y-5">
              <Badge
                name={
                  !index
                    ? "Discover"
                    : index === 1
                    ? "Tools"
                    : index === 2
                    ? "Launchpad"
                    : "Rewards"
                }
                color={
                  !index
                    ? "blue"
                    : index === 1
                    ? "blue"
                    : index === 2
                    ? "blue"
                    : "blue"
                }
              />
              <h3 className="text-lg font-semibold">{item.title}</h3>
              <span className="block text-neutral-500 dark:text-neutral-400">
                {item.desc}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionHowItWork;
